// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-file-dialog__container {
    position: relative;
    top: 5px;
}

.choose-file-dialog__menu{
    position: absolute;
    display: block;
    min-width: 4rem;
    text-align: center;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    border-radius: 4px;
    z-index: 100;
}

.choose-file-dialog__menu-item {
    cursor: pointer;
    text-align: left;
    padding: 1rem 2rem;
}

.choose-file-dialog__menu-item:hover {
    background: #26a69a;
    color: #fff;
}

.choose-file-dialog__attach-image {
    transform: rotate(45deg);
    font-size: 2.2rem;
    cursor: pointer;
    opacity: 0.7;
}

.choose-file-dialog__attach-image:hover:not(.disabled) {
    opacity: 1;
}

.choose-file-dialog__label {
    cursor: pointer;
}

 .input-file__hidden {
    display: none;
} 

.disabled
{
    cursor: default;
    user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/choose-file-dialog/ChooseFileDialog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,uGAAuG;IACvG,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;CAEC;IACG,aAAa;AACjB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".choose-file-dialog__container {\r\n    position: relative;\r\n    top: 5px;\r\n}\r\n\r\n.choose-file-dialog__menu{\r\n    position: absolute;\r\n    display: block;\r\n    min-width: 4rem;\r\n    text-align: center;\r\n    background-color: white;\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    border-radius: 4px;\r\n    z-index: 100;\r\n}\r\n\r\n.choose-file-dialog__menu-item {\r\n    cursor: pointer;\r\n    text-align: left;\r\n    padding: 1rem 2rem;\r\n}\r\n\r\n.choose-file-dialog__menu-item:hover {\r\n    background: #26a69a;\r\n    color: #fff;\r\n}\r\n\r\n.choose-file-dialog__attach-image {\r\n    transform: rotate(45deg);\r\n    font-size: 2.2rem;\r\n    cursor: pointer;\r\n    opacity: 0.7;\r\n}\r\n\r\n.choose-file-dialog__attach-image:hover:not(.disabled) {\r\n    opacity: 1;\r\n}\r\n\r\n.choose-file-dialog__label {\r\n    cursor: pointer;\r\n}\r\n\r\n .input-file__hidden {\r\n    display: none;\r\n} \r\n\r\n.disabled\r\n{\r\n    cursor: default;\r\n    user-select: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
